var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiresponding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 124,
    viewBox: "0 0 126 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9997 0.609375C97.2394 0.609375 125.039 28.1184 125.039 61.9998C125.039 95.8812 97.2394 123.39 62.9997 123.39C28.76 123.39 0.959961 95.8812 0.959961 61.9998C0.959961 28.1184 28.76 0.609375 62.9997 0.609375Z",
    fill: "#4B81EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.54 60.9876V61.0148C100.54 65.864 96.6024 69.8012 91.7532 69.8012C86.904 69.8012 82.9668 65.864 82.9668 61.0148V60.9876C82.9668 56.1384 86.904 52.2012 91.7532 52.2012C96.6024 52.2012 100.54 56.1384 100.54 60.9876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2388 60.9876V61.0148C73.2388 65.864 69.3016 69.8012 64.4524 69.8012C59.6032 69.8012 55.666 65.864 55.666 61.0148V60.9876C55.666 56.1384 59.6032 52.2012 64.4524 52.2012C69.3016 52.2012 73.2388 56.1384 73.2388 60.9876Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.938 60.9876V61.0148C45.938 65.864 42.0008 69.8012 37.1516 69.8012C32.3024 69.8012 28.3652 65.864 28.3652 61.0148V60.9876C28.3652 56.1384 32.3024 52.2012 37.1516 52.2012C42.0008 52.2012 45.938 56.1384 45.938 60.9876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiresponding);
export default __webpack_public_path__ + "static/media/airesponding.7081d6facf0c6a2b17086da0595468b5.svg";
export { ForwardRef as ReactComponent };